export default class CreateEditOrganisationUserViewModel {
    public email: string = '';
    public role: string = '';
    public organisation: string = '';
    public siteId?: string = undefined;
    constructor(orgid, siteId) {
        this.organisation = orgid;
        this.siteId = siteId;
    }
}